import React from "react";
import { useControlContext } from "rectangular-forms";

export const GroupError = (props) => {
  const { control } = useControlContext();
  const errors = control.errors;

  if (errors) {
    props.setHaveErros(true);
  } else {
    props.setHaveErros(false);
  }
  return (
    <React.Fragment>{errors ? props.children(errors) : null}</React.Fragment>
  );
};
